<script>
  import { Link } from "svelte-navigator";
  let isNavOpen = false;
  let innerWidth;
  const rem = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue("font-size")
    .split("px")
    .shift();
  $: isMobile = innerWidth < 60 * rem;
  $: document.body.classList[isNavOpen && isMobile ? "add" : "remove"](
    "noscroll"
  );

  import { useNavigate } from "svelte-navigator";

  const navigate = useNavigate();

  function toggleNav() {
    isMobile ? (isNavOpen = !isNavOpen) : (isNavOpen = false);
  }

  function navigateAndAnchor() {
    navigate(`/`);
    return false;
  }
</script>

<svelte:window bind:innerWidth />

<header>
  <h1 on:click={()=> isNavOpen = false}><Link to="/">ICY PENGUINS</Link></h1>
  <input
    type="checkbox"
    name="hamburger"
    checked={isNavOpen}
    on:click={toggleNav}
  />
  <label for="hamburger">
    <div class="top" />
    <div class="mid" />
    <div class="bottom" />
  </label>
  <nav>
    <ul>
      <li on:click={toggleNav}>
        <a href="#buy_a_penguin" on:click={navigateAndAnchor}>Buy a penguin</a>
      </li>
      <li on:click={toggleNav}>
        <a href="#the_nft" on:click={navigateAndAnchor}>The NFT</a>
      </li>
      <li on:click={toggleNav}>
        <a href="#roadmap" on:click={navigateAndAnchor}>Roadmap</a>
      </li>
      <li on:click={toggleNav} class="link">
        <Link to="/gallery">Gallery</Link>
      </li>
      <li on:click={toggleNav} class="link"><Link to="/faq">FAQ</Link></li>
      <div class="mobile">
        <li>
          <a href="https://instagram.com/" target="_blank"
            ><img src="images/instagram.svg" alt="instagram" />Instagram</a
          >
        </li>
        <li>
          <a href="https://instagram.com/" target="_blank"
            ><img src="images/twitter.svg" alt="twitter" />Twitter</a
          >
        </li>
        <li>
          <a href="https://instagram.com/" target="_blank"
            ><img src="images/discord.svg" alt="discord" />Discord</a
          >
        </li>
      </div>
    </ul>
  </nav>
  <ul>
    <li on:click={()=> isNavOpen = false}>
      <a href="https://instagram.com/" target="_blank"
        ><img src="images/instagram.svg" alt="instagram" />Instagram</a
      >
    </li>
    <li on:click={()=> isNavOpen = false}>
      <a href="https://instagram.com/" target="_blank"
        ><img src="images/twitter.svg" alt="twitter" />Twitter</a
      >
    </li>
    <li on:click={()=> isNavOpen = false}>
      <a href="https://instagram.com/" target="_blank"
        ><img src="images/discord.svg" alt="discord" />Discord</a
      >
    </li>
  </ul>
</header>

<style scoped>
  header {
    width: 100%;
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    font-style: italic;
    position: relative;
    background-color: #131114;
  }

  header h1 {
    font-size: 1.5rem;
    font-weight: 700;
    position: relative;
    z-index: 10;
  }

  header h1 > :global(a) {
    color: #fff;
  }

  header label {
    width: 25px;
    height: 17px;
    font-size: 0;
    background-color: transparent;
    border: none;
    position: relative;
    z-index: 10;
    display: none;
  }

  header label div {
    width: 100%;
    height: 2px;
    background-color: #fff;
    position: absolute;
  }

  header input {
    width: 25px;
    height: 17px;
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 11;
    display: none;
  }

  header input:checked ~ nav {
    transform: translateX(0%);
  }

  header input:checked ~ label div.top {
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
  }

  header input:checked ~ label div.mid {
    opacity: 0;
  }

  header input:checked ~ label div.bottom {
    bottom: 50%;
    transform: translateY(50%) rotate(-45deg);
  }

  header label div.top {
    top: 0;
    transition: 0.3s transform, 0.3s top;
  }

  header label div.mid {
    top: 50%;
    transform: translateY(-50%);
    transition: 0.3s transform, 0.3s opacity;
  }

  header label div.bottom {
    bottom: 0;
    transition: 0.3s transform, bottom 0.3s;
  }

  header input:focus-visible + label {
    outline: 1px solid white;
  }

  header nav ul {
    display: flex;
    list-style-type: none;
  }

  header nav ul .mobile {
    display: none;
    justify-content: center;
    align-items: center;
  }

  header nav ul .mobile li a {
    display: flex;
    align-items: center;
    font-size: 0;
  }

  header nav ul .mobile img {
    width: 24px;
    height: 24px;
  }

  header nav ul li a,
  .link > :global(a) {
    color: white;
    margin: 0 1rem;
  }

  header > ul {
    display: flex;
    list-style-type: none;
  }

  header > ul li a {
    font-size: 0;
    margin: 0 0.7rem;
  }
  header > ul li a img {
    width: 21px;
  }

  @media screen and (max-width: 60rem) {
    header nav {
      position: fixed;
      width: 100vw;
      height: 100vh;
      left: 0;
      top: 0;
      transform: translateX(-100%);
      z-index: 9;
      background-color: inherit;
      transition: 0.3s transform;
    }

    header nav ul {
      height: 100vh;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }

    header nav ul li {
      font-size: 2rem;
      margin: 1rem 0;
    }

    header > ul {
      display: none;
    }

    header input,
    header label {
      display: block;
    }

    header nav ul .mobile {
      display: flex;
    }

    header input {
      opacity: 0;
    }
  }
</style>
